export const increaseBet = (
  win,
  bet,
  base_bet,
  onLossIncrease,
  onLossPercent,
  onWinIncrease,
  onWinPercent,
  toFix
) => {
  // console.log('bet', bet)
  if (win > 0) {
    if (!onWinIncrease) {
      return base_bet
    }
    return (+bet + (bet * +onWinPercent) / 100).toFixed(toFix)
  }
  if (win < 0) {
    if (!onLossIncrease) {
      return base_bet
    }
    return (+bet + (bet * +onLossPercent) / 100).toFixed(toFix)
  }
  return bet
}

//   if (_win > 0) {
//     if (this.onWinPercent > 0) {
//       // increase bet on WIN
//       this.bet = (+this.bet + (this.bet * +this.onWinPercent) / 100).toFixed(
//         this.toFix
//       )
//     } else if (!this.onWinIncrease) {
//       // reset bet on WIN
//       this.bet = +this.base_bet
//     }
//   } else if (_win < 0) {
//     if (this.onLossPercent > 0) {
//       // increase bet on LOSE
//       this.bet = (+this.bet + (this.bet * +this.onLossPercent) / 100).toFixed(
//         this.toFix
//       )
//     } else if (!this.onLossIncrease) {
//       // reset bet on LOSE
//       this.bet = +this.base_bet
//     }
//   } else if (_win === 0) {
//     console.log('win was 0')
//   }
